import React from 'react';
import { Text } from '@/components/typography';
import { Link } from '@/components/links';

interface Props {
	title: string;
	link?: {
		text: string;
		href: string;
	};
}

function Overlay(props: Props) {
	const { link, title } = props;

	return (
		<div className="pointer-events-none fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-black/40">
			<div className="pointer-events-auto z-50 flex max-w-lg flex-col gap-3 rounded-lg bg-blue-500 p-6 text-center text-white">
				<strong className="text-xl font-semibold">{title}</strong>
				{link && (
					<Text variant="p2">
						<Link
							to={link.href}
							testId="deprecatedInsuranceInsurance"
							analyticsParam="deprecatedInsuranceInsurance"
							className="text-white"
							target="_blank"
						>
							{link.text}
						</Link>
					</Text>
				)}
			</div>
		</div>
	);
}

export default Overlay;
